module.exports = __webpack_public_path__ + "img/users-solid.f9a45ba4.svg";